import styled, { css } from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

import CommonContainer from 'ggApp/shared/common/Container';
import GroverCare from 'ggApp/shared/components/cards/ProductDetailsCard/badges/GroverCare';
import Delivery from 'ggApp/shared/components/cards/ProductDetailsCard/badges/Delivery';
import { EnergyLabel } from 'ggApp/shared/components/cards/ProductDetailsCard/EnergyLabels/EnergyLabel';
import RentalPeriod from 'ggApp/shared/components/cards/ProductDetailsCard/badges/RentalPeriod';
import ColorDropdown from 'ggApp/shared/components/cards/ProductDetailsCard/ColorSelector';
import TrialCard from 'ggApp/shared/components/cards/ProductDetailsCard/TrialCard';
import { LongRevocation } from 'ggApp/shared/components/cards/ProductDetailsCard/badges/LongRevocation';
import { MixableProductCard } from '../MixableProductCard';
import { FlexibleProductCard } from '../FlexibleProductCard';

export const MixActionsWrapper = styled.div``;

export const OriginalActionsWrapper = styled.div``;

export const MarketPrice = styled.div`
    ${({ theme }) => css(theme.typography.Paragraph)};
    text-decoration: line-through;
    margin-bottom: 16px;
`;

export const PlanPriceDetails = styled(CommonContainer)`
    align-items: flex-end;
    flex-wrap: wrap;
    margin-bottom: 16px;
    display: inline-block;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: none;
    `};
`;

export const OldPrice = styled.div`
    ${({ theme }) => css(theme.typography.Paragraph)};
    text-decoration: line-through;
    margin-right: 4px;
    display: inline;
`;

export const Price = styled.span`
    margin-right: 4px;
    display: inline;
    ${({ theme }) => css(theme.typography.Subheadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    white-space: nowrap;
    &::before {
        content: ' ';
    }
    ${({ withOldPrice, theme }) => withOldPrice
        && css`
            color: ${theme.colors.Color1};
            &::before {
                content: '';
            }
        `}
`;

export const TaxText = styled.div`
    ${({ theme }) => css(theme.typography.Paragraph)};
    display: inline;
`;

export const GroverCareBadge = styled(GroverCare)`
    margin-bottom: 16px;
`;

export const DeliveryBadge = styled(Delivery)`
    margin-bottom: 16px;
`;

export const EnergyLabelBadge = styled(EnergyLabel)`
    margin-bottom: 16px;
`;

export const RentalPeriodBadge = styled(RentalPeriod)`
    margin-bottom: 16px;
`;


export const RentalPlanSelectorWrap = styled.div`
    margin: 8px auto 16px;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 16px auto 24px;
    `}
`;

export const TrialDescription = styled(TrialCard)`
    margin-bottom: 16px;
`;

export const ColorSelector = styled(ColorDropdown)`
    margin-bottom: 16px;
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-bottom: 0px;
    `}
`;

export const Cta = styled(ButtonV2)`
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: none;
    `}
`;

export const CtaText = styled.div`
    ${({ theme }) => css(theme.typography.SmallHeadline)}
`;

export const MixableProductDetails = styled(MixableProductCard)`
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-top: 16px;
    `}
`;

export const FlexibleProductDetails = styled(FlexibleProductCard)`
    margin-top: 16px;
`;

export const LongRevocationBadge = styled(LongRevocation)`
    margin-bottom: 16px;
`;
